// extracted by mini-css-extract-plugin
module.exports = {"box":"FeedItem_box_2lLDk","cover":"FeedItem_cover_f7E8N"};